module.exports = __webpack_public_path__ + "static/media/search.4d1956a3.svg";